module.exports = "pegasus_template/assets/theme6/small/3.jpg";